/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/** PaymentMethodType */
export enum PaymentMethodType {
  Card = 'card',
  Ach = 'ach',
  DigitalWallet = 'digitalWallet',
}

/** PaymentMethodSetupProvider */
export enum PaymentMethodSetupProvider {
  Payabli = 'payabli',
  Plaid = 'plaid',
}

/** PaymentMethodSetupMode */
export enum PaymentMethodSetupMode {
  Card = 'card',
  Ach = 'ach',
  DigitalWallet = 'digitalWallet',
  BankAuth = 'bankAuth',
}

/** PaymentMethodPurpose */
export enum PaymentMethodPurpose {
  Collect = 'collect',
  Payout = 'payout',
}

/** PaymentEntityType */
export enum PaymentEntityType {
  Applicant = 'applicant',
  Tenant = 'tenant',
  Owner = 'owner',
  Vendor = 'vendor',
  Company = 'company',
}

/** ConnectedAccountStatus */
export enum ConnectedAccountStatus {
  Requested = 'requested',
  Pending = 'pending',
  UnderReview = 'underReview',
  Approved = 'approved',
  Activated = 'activated',
  Rejected = 'rejected',
  Suspended = 'suspended',
  Exception = 'exception',
  Denied = 'denied',
}

/** ConnectedAccountDocumentType */
export enum ConnectedAccountDocumentType {
  Agreement = 'agreement',
  BankStatement = 'bankStatement',
  BankVerification = 'bankVerification',
  FundFlow = 'fundFlow',
  Underwriting = 'underwriting',
  Compliance = 'compliance',
  Other = 'other',
}

/** CardType */
export enum CardType {
  Debit = 'debit',
  Credit = 'credit',
}

/** BankAccountType */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

/** CreatePaymentMethodRequestDto */
export type CreatePaymentMethodRequestDto = BaseCreatePaymentMethodRequestDto &
  (
    | BaseCreatePaymentMethodRequestDtoSourceMapping<'CreateTokenPaymentMethodRequestDto', CreateTokenPaymentMethodRequestDto>
    | BaseCreatePaymentMethodRequestDtoSourceMapping<'CreateCardPaymentMethodRequestDto', CreateCardPaymentMethodRequestDto>
    | BaseCreatePaymentMethodRequestDtoSourceMapping<'CreateAchPaymentMethodRequestDto', CreateAchPaymentMethodRequestDto>
  );

/** Address */
export interface Address {
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
}

/** CardExpiration */
export interface CardExpiration {
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
}

/** ConnectedAccountDocumentDto */
export interface ConnectedAccountDocumentDto {
  fileId: string;
  type: ConnectedAccountDocumentType;
  description?: string;
  /** @format date-time */
  uploadedAt: string;
}

/** ConnectedAccountDto */
export interface ConnectedAccountDto {
  id: string;
  companyId: string;
  bankAccountId: string;
  status: ConnectedAccountStatus;
  companyBusinessInfoId: string;
  documents: ConnectedAccountDocumentDto[];
  denyReason?: string;
}

/** ConnectedAccountDtoPaginationDto */
export interface ConnectedAccountDtoPaginationDto {
  items: ConnectedAccountDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** CreateAchPaymentMethodRequestDto */
export type CreateAchPaymentMethodRequestDto = (UtilRequiredKeys<BaseCreatePaymentMethodRequestDto, 'source'> & {
  /**
   * @minLength 9
   * @maxLength 9
   */
  routingNumber: string;
  /**
   * @minLength 4
   * @maxLength 17
   */
  accountNumber: string;
  accountType: BankAccountType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  holderName: string;
}) & {
  source: 'ach';
};

/** CreateCardPaymentMethodRequestDto */
export type CreateCardPaymentMethodRequestDto = (UtilRequiredKeys<BaseCreatePaymentMethodRequestDto, 'source'> & {
  /**
   * @minLength 13
   * @maxLength 19
   */
  cardNumber: string;
  /**
   * @minLength 4
   * @maxLength 7
   */
  cardExpiry: string;
  /**
   * @minLength 3
   * @maxLength 4
   */
  cardCvv: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  cardHolder: string;
  /**
   * @minLength 0
   * @maxLength 10
   */
  cardZip?: string;
}) & {
  source: 'card';
};

/** CreateTokenPaymentMethodRequestDto */
export type CreateTokenPaymentMethodRequestDto = (UtilRequiredKeys<BaseCreatePaymentMethodRequestDto, 'source'> & {
  type: PaymentMethodType;
  /**
   * @minLength 1
   * @maxLength 500
   */
  token: string;
}) & {
  source: 'token';
};

/** DeactivatePaymentMethodRequestDto */
export interface DeactivatePaymentMethodRequestDto {
  /**
   * @minLength 1
   * @maxLength 500
   */
  reason: string;
}

/** DeletePaymentMethodRequestDto */
export type DeletePaymentMethodRequestDto = object;

/** ExchangeAuthorizedMethodsRequestDto */
export interface ExchangeAuthorizedMethodsRequestDto {
  /**
   * @minLength 1
   * @maxLength 500
   */
  token: string;
}

/** ExchangedAuthorizedMethodsDto */
export interface ExchangedAuthorizedMethodsDto {
  paymentMethods: PaymentMethodDto[];
}

/** PaymentMethodDto */
export interface PaymentMethodDto {
  id: string;
  type: PaymentMethodType;
  brand?: string;
  holder?: string;
  last4?: string;
  expires?: CardExpiration;
  cardType?: CardType;
  accountType?: BankAccountType;
  description?: string;
  /** @format date-time */
  deactivated?: string;
  isDeactivated: boolean;
  deactivationReason?: string;
  /** @format date-time */
  created: string;
  capabilities: PaymentMethodPurpose[];
}

/** PaymentMethodDtoPaginationDto */
export interface PaymentMethodDtoPaginationDto {
  items: PaymentMethodDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** PaymentMethodSetupDto */
export interface PaymentMethodSetupDto {
  provider: PaymentMethodSetupProvider;
  mode: PaymentMethodSetupMode;
  /** @format date-time */
  expires?: string;
  publicToken: string;
  metadata?: Record<string, string>;
}

/** ReactivatePaymentMethodRequestDto */
export type ReactivatePaymentMethodRequestDto = object;

/** RequestConnectedAccountDocumentDto */
export interface RequestConnectedAccountDocumentDto {
  /** @minLength 1 */
  uploadSessionId: string;
  type: ConnectedAccountDocumentType;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** RequestConnectedAccountRequestDto */
export interface RequestConnectedAccountRequestDto {
  /** @minLength 1 */
  bankAccountId: string;
  /** @minLength 1 */
  companyBusinessInfoId: string;
  documents: RequestConnectedAccountDocumentDto[];
  /**
   * @minLength 1
   * @maxLength 200
   */
  signerName: string;
  /**
   * @format email
   * @minLength 1
   */
  signerEmail: string;
  /**
   * @format tel
   * @minLength 1
   */
  signerPhone: string;
  signerAddress: RequiredAddressDto;
  /**
   * @minLength 1
   * @pattern ^\d{3}-?\d{2}-?\d{4}$
   */
  signerSsn: string;
  /** @format date */
  signerDateOfBirth: string;
  /** @format date */
  accepted: string;
}

/** RequestUploadSessionDto */
export interface RequestUploadSessionDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @format int32
   * @min 1
   * @max 9223372036854776000
   */
  fileSize: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  contentType: string;
}

/** RequiredAddressDto */
export interface RequiredAddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode: string;
  /**
   * @minLength 3
   * @maxLength 25
   */
  country?: string;
}

/** StartPaymentMethodSetupRequestDto */
export interface StartPaymentMethodSetupRequestDto {
  /** @default "card" */
  mode?: PaymentMethodSetupMode;
}

/** UpdatePaymentMethodRequestDto */
export interface UpdatePaymentMethodRequestDto {
  /**
   * @minLength 2
   * @maxLength 250
   */
  name?: string;
  /**
   * @format email
   * @minLength 0
   * @maxLength 250
   */
  email?: string;
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  phone?: string;
  address?: Address;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  metadata?: Record<string, string>;
}

/** UploadSessionDto */
export interface UploadSessionDto {
  sessionId: string;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
}

/** CreatePaymentMethodRequestDto */
interface BaseCreatePaymentMethodRequestDto {
  source: 'ach' | 'card' | 'token';
  description?: string;
}

type BaseCreatePaymentMethodRequestDtoSourceMapping<Key, Type> = {
  source: Key;
} & Type;

export interface GetConnectedAccountsParams {
  /** @minItems 1 */
  ids?: string[];
  companyId?: string;
  /** @minItems 1 */
  bankAccountIds?: string[];
  /** @minItems 1 */
  statuses?: ConnectedAccountStatus[];
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetConnectedAccountParams {
  /** @format int64 */
  connectedAccountId: string;
}

export interface GetPaymentMethodsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  ids?: string[];
  /** @minItems 1 */
  types?: PaymentMethodType[];
  deactivated?: boolean;
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  'created.startInclusive'?: boolean;
  'created.endInclusive'?: boolean;
}

export interface GetPaymentMethodParams {
  /** @format int64 */
  methodId: string;
}

export interface UpdatePaymentMethodParams {
  /** @format int64 */
  methodId: string;
}

export interface DeletePaymentMethodParams {
  /** @format int64 */
  methodId: string;
}

export interface DeactivatePaymentMethodParams {
  /** @format int64 */
  methodId: string;
}

export interface ReactivatePaymentMethodParams {
  /** @format int64 */
  methodId: string;
}

export interface StartPaymentMethodSetupForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
}

export interface CreatePaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
}

export interface GetPaymentMethodsForEntityParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  ids?: string[];
  /** @minItems 1 */
  types?: PaymentMethodType[];
  deactivated?: boolean;
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  'created.startInclusive'?: boolean;
  'created.endInclusive'?: boolean;
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
}

export interface ExchangeAuthorizedMethodsForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
}

export interface GetPaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
  /** @format int64 */
  methodId: string;
}

export interface UpdatePaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
  /** @format int64 */
  methodId: string;
}

export interface DeletePaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
  /** @format int64 */
  methodId: string;
}

export interface DeactivatePaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
  /** @format int64 */
  methodId: string;
}

export interface ReactivatePaymentMethodForEntityParams {
  entityType: PaymentEntityType;
  /** @format int64 */
  entityId: string;
  /** @format int64 */
  methodId: string;
}
